import { TableColumnsType } from 'antd';
import { DataCertificates } from 'store/ducks/Reportings/types';

export const certificateColumns: TableColumnsType<DataCertificates> = [
  {
    title: 'ICT Service',
    width: 150,
    dataIndex: 'ict_service_name',
    key: 'ict_service_name',
  },
  {
    title: 'Certificate Description',
    width: 150,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Date of Issuance',
    width: 150,
    dataIndex: 'date_of_issuance',
    key: 'date_of_issuance',
  },
  {
    title: 'Validity',
    width: 150,
    dataIndex: 'validity',
    key: 'validity',
  },
  {
    title: 'Certificate Valid from',
    width: 150,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'Certificate Valid to',
    width: 150,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Certificate Registry',
    width: 150,
    dataIndex: 'certificate_registry',
    key: 'certificate_registry',
  },
  {
    title: 'Date of Certificate Register',
    width: 150,
    dataIndex: 'date_of_certificate_register',
    key: 'date_of_certificate_register',
  },
];
